import React, { FC, useState } from "react"

import { Button, Menu, MenuItem, Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { RoutePath } from "routes/Route.types"

import { TabNameTypes } from "./Teachers"

interface TeachersMobileMenuProps {
  tabName: TabNameTypes
  onTabChange: (tab: "active" | "pending") => void
}

const TeachersMobileMenu: FC<TeachersMobileMenuProps> = ({ tabName, onTabChange }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(menuAnchorEl)

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setMenuAnchorEl(null)
  }

  const handleMenuSelect = (option: "active" | "pending" | "addTeacher") => {
    if (option === "addTeacher") {
      navigate(RoutePath.ADMIN_ADD_TEACHER)
    } else {
      onTabChange(option)
    }
    handleMenuClose()
  }

  return (
    <Stack flexDirection="row" justifyContent="flex-start">
      <Button
        onClick={handleMenuClick}
        sx={{
          borderRadius: "8px 8px 0 0",
          borderBottom: "none",
        }}
      >
        {tabName === "active"
          ? t("adminDashboard.active")
          : tabName === "pending"
          ? t("adminDashboard.pending")
          : t("adminDashboard.addTeacher")}
      </Button>
      <Menu
        anchorEl={menuAnchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => handleMenuSelect("active")}
          selected={tabName === "active"}
        >
          {t("adminDashboard.active")}
        </MenuItem>
        <MenuItem
          onClick={() => handleMenuSelect("pending")}
          selected={tabName === "pending"}
        >
          {t("adminDashboard.pending")}
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelect("addTeacher")}>
          {t("adminDashboard.addTeacher")}
        </MenuItem>
      </Menu>
    </Stack>
  )
}

export default TeachersMobileMenu
